import { createTheme } from "@mui/material/styles";
const commonTheme = {
  typography: {
    fontFamily: "Roboto, sans-serif",
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 700,
    h1: {
      letterSpacing: 0,
      fontSize: 80,
    },
    h2: {
      fontSize: 48,
    },
    h3: {
      fontSize: 42,
    },
    h4: {
      fontSize: 36,
    },
    h5: {
      fontSize: 20,
    },
    h6: {
      fontSize: 18,
    },
    subtitle1: {
      fontSize: 18,
    },
    body1: {
      fontSize: 16,
    },
    body2: {
      fontSize: 14,
    },
  },
};
export const lightDefaultTheme = createTheme({
  palette: {
    mode: "light",
    background: {
      paper: "#ffffff",
      default: "#ffffff",
    },
    neutral: {
      main: "#ffffff",
      contrastText: "#262626",
    },
    neutralText: {
      main: "#262626",
    },
  },
  typography: {
    ...commonTheme.typography,
  },
});

export const darkDefaultTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      paper: "#262626",
      default: "#262626",
    },
    neutral: {
      main: "#262626",
      contrastText: "#ffffff",
    },
    neutralText: {
      main: "#ffffff",
    },
  },
  typography: {
    ...commonTheme.typography,
    // h1: {
    //   ...commonTheme.typography.h1,
    //   color: "#890F0D",
    // },
  },
});
